import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('discardSafeSendersOption')(function discardSafeSendersOption(state) {
    var optionState = state.optionState;
    optionState.safeSenders = null;
}));
//# sourceMappingURL=discardSafeSendersOption.js.map